import { module } from 'angular';
import App from '../../../app';

class SCR0903Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, codeService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		this.codes = data.codes;
		
		this.initWindow(960, 700);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initIntrfcGridOption();
			this.getInteraceList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMciInterface'), bxMsg.getMessages('manageMetaInfo'));	
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initIntrfcGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
			{
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
			{fieldName: "intrfcId"}, {fieldName: "intrfcNm"},
			{fieldName: "lv1Cd"}, {fieldName: "lv2Cd"}, {fieldName: "lv3Cd"},
            {
            	fieldName: "lvCds",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return values[fieldNames.indexOf('lv1Cd')] + '/' + values[fieldNames.indexOf('lv2Cd')] + '/' + values[fieldNames.indexOf('lv3Cd')];
        		}
    		}, 
            {fieldName: "trxDscd"}, {fieldName: "regManId"}, {fieldName: "workStatusCd"}, 
            {
            	fieldName: "workStatusCdTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('WORK_STATUS_CD', values[fieldNames.indexOf('workStatusCd')]);
        		}
    		}, 
    		 {
            	fieldName: "trxDscdTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('TRAN_DSCD', values[fieldNames.indexOf('trxDscd')]);
        		}
    		} 
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "intrfcId", fieldName: "intrfcId", header : { text: this.text.intrfcId } , width: 120, styles: { textAlignment: 'center' } },
			{ name: "intrfcNm", fieldName: "intrfcNm", header : { text: this.text.intrfcNm }, width: 180, styles: { textWrap: 'ellipse' } },
			{ name: "lvCds", fieldName: "lvCds", header : { text: this.text.lvCds }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "trxDscdTxt", fieldName: "trxDscdTxt", header : { text:  this.text.trxTypeDscd }, width: 80, styles: { textAlignment: 'center' }  },
			{ name: "regManId", fieldName: "regManId", header : { text: this.text.regManId }, width: 70, styles: { textAlignment: 'center' } },
			{ name: "workStatusCdTxt", fieldName: "workStatusCdTxt", header : { text: this.text.workStatusCd }, width: 100, styles: { textAlignment: 'center' } }
		]);
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getInteraceList(goToFirst = false){
		const {pageNumber, pageSize} = this.getPageInfo();
		let url = `/intrfccoms?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		if(this.data.intrfcTypeCd) url += `&intrfcTypeCd=${this.data.intrfcTypeCd}&trxDscd=BATCH`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.intrfccombsOutList);
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getInteraceList(true);
	}
	
	search(){
		this.getInteraceList(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	searchApplicationCodes(){
		this.popupService.openModal('SCR1402', { limitLvCd: 0 })
						 .then((codes) => {
							this.searchParam.lv1Cd = "";
							this.searchParam.lv1CdNm = "";
							this.searchParam.lv2Cd = "";
							this.searchParam.lv2CdNm = "";
							this.searchParam.lv3Cd = "";
							this.searchParam.lv3CdNm = "";
							 
							codes.map((code, index) =>{
								this.searchParam[`lv${index +1}Cd`] = code.appCd;
								this.searchParam[`lv${index +1}CdNm`] = code.appCdNm;
							});
						 })
						 .catch(()=>{});
	}
	
	openRegManPopup(){
		this.popupService.openModal('SCR0102')
						 .then(user => this.searchParam.regManId = user.userId)
						 .catch(()=>{});
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getInteraceList(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
	
	getInterface(intrfcId) {
		this.httpService.get(`/intrfccoms/${intrfcId}`).then(res => {
			this.$uibModalInstance.close(res);
		});
	}
	
	getLvCd(intrfccoms) {
		let lvCd = '';
		
		if(intrfccoms) {
			if(intrfccoms.lv1Cd) {
				lvCd = intrfccoms.lv1Cd;
			}
			
			if(intrfccoms.lv2Cd) {
				lvCd += '/' + intrfccoms.lv2Cd;
			}
			
			if(intrfccoms.lv3Cd) {
				lvCd += '/' + intrfccoms.lv3Cd;
			}	
		}
		
		return lvCd;
	}

}

module(App.name).controller('SCR0903Controller', SCR0903Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0903/SCR0903.controller.js